import { Button } from '@/components/ui/button';
import amex from '@/assets/amex.svg';
import visa from '@/assets/visa.svg';
import paypal from "@/assets/paypal.svg";
import mastercard from "@/assets/mastercard.svg";
import discover from "@/assets/discover.svg";
import applePay from "@/assets/apple.svg";
import { useIsLocationAllowed } from '@/hooks/useIsLocationAllowed';
import { useEffect } from 'react';
import { useModal } from '@/hooks/useModal';
import { ErrorModal } from './Modals/ErrorModal';
import { useViewTransition } from '@/hooks/useViewTransition';
import { centsToPrettyDollars } from '@skillscratch/shared-util';
import { useMemo } from 'react';
import { Gift } from 'lucide-react'
import { useBalance } from '@/hooks/useBalance';



export function BalanceCard() {
    const [isLocationAllowed] = useIsLocationAllowed();
    const { openModal } = useModal();
    const { navigateNormal } = useViewTransition(); 

    const [userData, isUserDataLoading, userDataError] = useBalance();


    const stringifiedBalance = useMemo(() => {
        return userData?.balance !== undefined ? centsToPrettyDollars(userData?.balance) : "$0.00";
    }, [userData?.balance]);

    const stringifiedPromoBalance = useMemo(() => {
        return userData?.promoBalance !== undefined ? centsToPrettyDollars(userData?.promoBalance) : "$0.00";
    }, [userData?.promoBalance])

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (userDataError) {
            openModal(<ErrorModal message={userDataError.message}/>);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userDataError]);

    const openWallet = () => {
        navigateNormal("/wallet", {
            replace: false,
            viewTransition: true,
          });
    } 

    return (
        <div className="max-w-md rounded-lg bg-white p-4 shadow mx-auto w-full btn-bounce-subtle" id='balancecard-card'>
            <div className="flex items-start justify-between mb-2 border-b-2 border-gray pb-4">
                <div>
                    <h1 className="text-2xl font-bold text-blue-dark tracking-tight">
                        {isUserDataLoading ? "$-.--" : stringifiedBalance}
                    </h1>
                    {
                        (userData?.promoBalance ?? 0) > 0 ? (
                            <span className='flex flex-row items-center gap-0.5 text-blue-dark font-medium text-sm opacity-80'>
                                <Gift size={16} />
                                <span>{stringifiedPromoBalance}</span>
                            </span>
                        ) : null
                    }
                    {/* <p className="text-slate text-lg">Balance</p> */}
                </div>
                <Button variant='wallet-btn' size='walletBtn' className="bg-blue-dark text-white" onClick={() => openWallet()}>
                    My wallet
                </Button>
            </div>
        
            <div className="mt-4">
                <div className="flex items-center text-md text-slate justify-between">
                    <span>{`${isLocationAllowed?.locationName} Methods`}</span>
                    <div className="flex items-center space-x-0.5">
                        <img src={applePay} alt="Apple Pay" className="w-7" />
                        <img src={paypal} alt="PayPal" className="w-7" />
                        <img src={mastercard} alt="Mastercard" className="w-7" />
                        <img src={visa} alt="Visa" className="w-7" />
                        <img src={amex} alt="American Express" className="w-7" />
                        <img src={discover} alt="Discover" className="w-7" />
                    </div>
                </div>
            </div>
        </div>
  );
};